export default "__VITE_ASSET__BSO5BBzu__"